import {
  GridColumnMoneyOptionsType,
  GridColumnType,
  GridSizePropsType,
} from '@/ui-kit/components/grid/enums';
import { CurrencyCode } from '@/ui-kit/helpers/NumberFormatHelper';
import { StyleSizeType } from '@/ui-kit/styles/enums';
import { EstimatedFeesTableColumnKey } from '../enums';

export const ESTIMATED_FEES_TABLE_COLUMNS = [
  {
    key: EstimatedFeesTableColumnKey.Characteristic,
    type: GridColumnType.Text,
  },
  {
    key: EstimatedFeesTableColumnKey.MoneyAmount,
    type: GridColumnType.Money,
    options: {
      [GridColumnMoneyOptionsType.Currency]: CurrencyCode.CanadianDollars,
    },
  },
];

export const ESTIMATED_FEES_TABLE_SIZES = [
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.XSmall,
    [GridSizePropsType.TableSize]: StyleSizeType.Small,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.Small,
    [GridSizePropsType.TableSize]: StyleSizeType.Small,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.Medium,
    [GridSizePropsType.TableSize]: StyleSizeType.Medium,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.Large,
    [GridSizePropsType.TableSize]: StyleSizeType.Medium,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.XLarge,
    [GridSizePropsType.TableSize]: StyleSizeType.Medium,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.XXLarge,
    [GridSizePropsType.TableSize]: StyleSizeType.Medium,
  },
];
